export const scrollToFirstInvalidField = ({
  formKey = "form",
  totalTop = 135,
}) => {
  requestAnimationFrame(() => {
    const target = document.querySelector(
      'input[aria-invalid="true"], textarea[aria-invalid="true"], select[aria-invalid="true"]',
    );

    if (!target) return;
    const ariaDetails =
      target.closest("[data-scroll-by]")?.getAttribute("data-scroll-by") || formKey;

    const container = document.getElementById(ariaDetails);

    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();

    if (ariaDetails !== "form") {
      totalTop = 100;
    }

    const targetScrollPosition =
      container.scrollTop + (targetRect.top - containerRect.top) - totalTop;

    container.scrollTo({
      top: Math.max(0, targetScrollPosition),
      behavior: "smooth",
    });

    // focus after scroll starts without affecting scroll position
    setTimeout(() => {
      try {
        target.focus({
          preventScroll: true,
        });
      } catch {
        target.focus();
      }
    }, 300);
  });
};
